import Event from '../../core/Event';

export default class EstimationPeriodGetRequested extends Event {
    public static type = 'EstimationPeriodGetRequested';

    constructor() {
        super(EstimationPeriodGetRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/admin/events/EstimationPeriodGetRequested.ts